import React, { Component } from 'react'
import PropTypes from 'prop-types'
import QuestTypeIcon from './QuestTypeIcon'

const QuestIcon = ({
  quest,
  questType,
  showCompletedCheck,
  showQuestType,
  showQuestTypeTooltip,
  clickHandler,
  size,
  customClass,
  borderRadius = size
}) => {
  const style = {
    height: `${size}px`,
    width: `${size}px`,
    borderRadius: `${borderRadius}px`,
    border: !showCompletedCheck ? '1px solid #DEDFE0' : 'none',
    fontSize: '12px' // for alt text
  }

  return (
    <div
      style={{
        display: 'inline-block',
        position: 'relative',
        height: `${size}px`
      }}
      className={`icon-wrapper ${customClass || ''}`}
      onClick={clickHandler}
    >
      <img
        alt={quest.name}
        className="icon"
        style={style}
        src={quest.icon_image_url}
      />

      {showCompletedCheck && (
        <div className="quest-icon-completed">
          <div className='completed-check'
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: `${size}px`,
              height: `${size}px`,
              borderRadius: `${size}px`,
              backgroundSize: '100%',
              zIndex: 11
            }}
          />
          <div className='completed-check-bg'
           style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: `${size}px`,
            backgroundSize: '100%',
            background: 'rgba(36,54,70,0.3)',
            zIndex: 10
          }}
        />
        </div>
      )}

      {showQuestType && questType && (
        <QuestTypeIcon
          quest={quest}
          questType={questType}
          displayTooltip={showQuestTypeTooltip}
        />
      )}
    </div>
  )
}

QuestIcon.defaultProps = {
  showCompletedCheck: false,
  showQuestType: true,
  showQuestTypeTooltip: true
}

QuestIcon.propTypes = {
  quest: PropTypes.object,
  questType: PropTypes.string,
  clickHandler: PropTypes.func,
  showCompletedCheck: PropTypes.bool,
  showQuestType: PropTypes.bool,
  showQuestTypeTooltip: PropTypes.bool,
  size: PropTypes.number,
  customClass: PropTypes.string
}

export default QuestIcon
